import React from 'react';

import { TemplatesProvider } from 'Templates';
import {
  ScreenAllFilters,
  ScreenFilters,
  ScreenFiltersApply,
} from 'components/Filters';
import { ScreenPresets } from 'components/Presets';

import { Screen, withScreen } from '@gogame/screens';
import { createScreenRoute } from '@gogame/screens';
import { Route } from '@gogame/screens';
import { Sentry } from '@gogame/components';
import AllFilters from './components/Filters/AllFilters';
import PrimaryFilters from './components/Filters/PrimaryFilters';
import SpendAdjustmentsDataTable from './components/SpendAdjustmentDataTable';
import { SpendAdjustmentDetailsRouteElement } from './components/SpendAdjustmentDetails';
import {
  spendAdjustmentLink,
  spendAdjustmentDetailsLink,
  spendAdjustmentSearchParams,
} from './navigation';
import { EMPTY_FILTERS, mapStateToPreset } from './schemas';
import screenReducer from './screenReducer';

const id = 7;
const permission = 4;

const SpendAdjustments = withScreen({
  name: 'spend-adjustments',
  searchParams: spendAdjustmentSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <ScreenPresets mapStateToPreset={mapStateToPreset} />
        <ScreenFilters emptyValues={EMPTY_FILTERS}>
          <PrimaryFilters />
          <ScreenAllFilters sidePage={AllFilters} />
          <ScreenFiltersApply />
        </ScreenFilters>
        <SpendAdjustmentsDataTable />
      </Screen.Body>
      <Sentry.Routes>
        <Route
          path={spendAdjustmentDetailsLink.path}
          element={<SpendAdjustmentDetailsRouteElement />}
        />
      </Sentry.Routes>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'Spend Adjustments',
  link: spendAdjustmentLink,
  screen: (
    <TemplatesProvider serverPageId={id}>
      <SpendAdjustments />
    </TemplatesProvider>
  ),
  id: id,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/sections/360003141774-Spend-Adjustments',
});
